import { useTranslation } from 'react-i18next';

const cardStyle = {
  backgroundColor: 'rgba(0,0,0,0.25)',
  borderRadius: '12px',
  padding: '30px',
  border: '1px solid rgba(255,212,81,0.15)',
  height: '100%'
};

const cardTitleStyle = {
  fontSize: '16px',
  fontWeight: 700,
  color: '#ffd451',
  marginBottom: '12px',
  letterSpacing: '1px',
  fontFamily: 'Raleway, sans-serif',
  textTransform: 'uppercase'
};

const cardTextStyle = {
  fontSize: '15px',
  color: '#b0bec5',
  lineHeight: '1.7',
  margin: 0
};

export const About = (props) => {
  const { t } = useTranslation();

  return (
    <section id='about' style={{ padding: '80px 0' }}>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>{t('About.title')}</h2>
        </div>
        <p style={{
          fontSize: '20px',
          color: '#cfd8dc',
          fontWeight: 300,
          textAlign: 'center',
          maxWidth: '700px',
          margin: '0 auto 50px',
          lineHeight: '1.6'
        }}>
          {t('About.lead')}
        </p>
        <div className='row'>
          <div className='col-md-6' style={{ marginBottom: '20px' }}>
            <div style={cardStyle}>
              <h3 style={cardTitleStyle}>{t('About.card1Title')}</h3>
              <p style={cardTextStyle}>{t('About.card1Text')}</p>
            </div>
          </div>
          <div className='col-md-6' style={{ marginBottom: '20px' }}>
            <div style={cardStyle}>
              <h3 style={cardTitleStyle}>{t('About.card2Title')}</h3>
              <p style={cardTextStyle}>{t('About.card2Text')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
